import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

export const NoNotifications = styled.div`
  color: ${COLORS.secondaryLight};
`;

export const NotificationDetailsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const NotificationDetailsItem = styled.div`
  flex: 1;
`;
